import { call, put, takeLatest, all } from "redux-saga/effects";
import {
  VALIDATE_EMAIL,
  VALIDATE_EMAIL_SUCCEEDED,
  VALIDATE_EMAIL_FAILED,
  LOAD_SINGLE_EMAILS,
} from "../../common/constants";
import * as api from "../../services/fileUpload";
import { showAlert } from "../../utility/alertHelper";





function* emailValidate(action) {
  // console.log(action);
  try {
    // calling api to verify single email
    const fileUploadResponse= yield call(api.validateEmail, {
      email: action.email,
    });

    // loading single emails 
    yield put({type: LOAD_SINGLE_EMAILS, userdata: {username: action.username}});

    yield put({
      type: VALIDATE_EMAIL_SUCCEEDED,
      singleEmail: {
        email: action.email,
        status: 1,
        result: fileUploadResponse,
      },
    });


    showAlert({
      msg_text: fileUploadResponse.msg,
      msg_type: fileUploadResponse.msg_type,
    });

  } catch (e) {
    yield put({
      type: VALIDATE_EMAIL_FAILED,
      singleEmail: { email: action.email, status: 1, result: "failed" },
    });
  }
}

function* emailValidateSaga() {
  yield takeLatest(VALIDATE_EMAIL, emailValidate);
}

export default emailValidateSaga;



// WEBPACK FOOTER //
// ./src/Containers/SingleEmailValidation/sagas.js